import { useQuery } from "@tanstack/react-query";
import { getAuditTrail } from "controller/api";
import { queryKeys } from "controller/cache";
import type {
  ApiErrorType,
  GetAuditTrailInput,
  ServiceAuditTrailEntry,
} from "shared";
import { sentryLogger } from "utilz";

export const useGetAuditTrail = ({
  serviceId,
  serviceType,
  enabled = true,
}: GetAuditTrailInput & { enabled?: boolean }) => {
  return useQuery<ServiceAuditTrailEntry[]>({
    queryKey: queryKeys.auditTrail.byService(serviceType, serviceId),
    queryFn: () => getAuditTrail({ serviceId, serviceType }),
    enabled: Boolean(serviceId) && enabled,
    onError: (error) =>
      sentryLogger({
        error: error as ApiErrorType,
        workflow: "ticket",
        level: "error",
        functionName: "getAuditTrail",
      }),
  });
};
